import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-212" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-3xl font-extrabold uppercase leading-tight tracking-tight text-foreground sm:text-4xl" data-id="element-213" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-214" data-mp="n09ajoyil75h">
        <span className="h-1 w-10 rounded-full bg-primary" data-id="element-215" data-mp="i76d35qm9dk0" />
        <span className="glow-line h-1 w-3 rounded-full bg-highlight" data-id="element-216" data-mp="d8lo62gtegav" />
      </span>
    </div>;
}